/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WidgetRoleOrder } from './WidgetRoleOrder';
import {
    WidgetRoleOrderFromJSON,
    WidgetRoleOrderFromJSONTyped,
    WidgetRoleOrderToJSON,
    WidgetRoleOrderToJSONTyped,
} from './WidgetRoleOrder';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetWidgetSettingsResponse
 */
export interface GetWidgetSettingsResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetWidgetSettingsResponse
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetWidgetSettingsResponse
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof GetWidgetSettingsResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetWidgetSettingsResponse
     */
    displayName: string | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetWidgetSettingsResponse
     */
    sortOrder: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetWidgetSettingsResponse
     */
    roles: Array<string>;
    /**
     * 
     * @type {Array<WidgetRoleOrder>}
     * @memberof GetWidgetSettingsResponse
     */
    roleOrders: Array<WidgetRoleOrder>;
}

/**
 * Check if a given object implements the GetWidgetSettingsResponse interface.
 */
export function instanceOfGetWidgetSettingsResponse(value: object): value is GetWidgetSettingsResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('roleOrders' in value) || value['roleOrders'] === undefined) return false;
    return true;
}

export function GetWidgetSettingsResponseFromJSON(json: any): GetWidgetSettingsResponse {
    return GetWidgetSettingsResponseFromJSONTyped(json, false);
}

export function GetWidgetSettingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetWidgetSettingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'key': json['key'],
        'name': json['name'],
        'displayName': json['displayName'],
        'sortOrder': ApiUserTasksGetPageParameterFromJSON(json['sortOrder']),
        'roles': json['roles'],
        'roleOrders': ((json['roleOrders'] as Array<any>).map(WidgetRoleOrderFromJSON)),
    };
}

export function GetWidgetSettingsResponseToJSON(json: any): GetWidgetSettingsResponse {
    return GetWidgetSettingsResponseToJSONTyped(json, false);
}

export function GetWidgetSettingsResponseToJSONTyped(value?: GetWidgetSettingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'key': value['key'],
        'name': value['name'],
        'displayName': value['displayName'],
        'sortOrder': ApiUserTasksGetPageParameterToJSON(value['sortOrder']),
        'roles': value['roles'],
        'roleOrders': ((value['roleOrders'] as Array<any>).map(WidgetRoleOrderToJSON)),
    };
}

